import { useCallback } from "react";
import { WEB_VIEW_EXPERIMENT_TO_REDUCER_MAPPING } from "../utils/statsig-ab-utils/constant";
import { useDispatch } from "react-redux";
import { setExperiment as setExperimentConnect } from "../components/shared/ab-experiment/actions";
import { getDecodedWebViewUrlParameter } from "../utils/helpers/get-web-view-experiments";
import { updateExtendedWarrantySelection } from "../components/au.mobile/car-details/actions";
import parseLocationSearchParams from "../utils/helpers/parse-location-search-params";
import { EXPERIMENT_TYPE } from "../constants/optimize-constants";

const getSinglePageTdQueryVariant = (queryParams = {}) => {
    if (!Object.prototype.hasOwnProperty.call(queryParams, "msiteSinglePageTd")) {
        return undefined;
    }

    const variant = queryParams.msiteSinglePageTd;

    if (!variant || variant === "null") {
        return null;
    }

    return variant;
};

const useWebViewData = (search) => {
    const dispatch = useDispatch();

    const resetStoreWithWebViewData = useCallback(() => {
        const { data: { experiments: webViewExperiments = {}, isCDPExtendedWarrantySelected = false } = {} } = getDecodedWebViewUrlParameter(search) || {};

        const queryParams = parseLocationSearchParams(search);
        const { isWebView: isWebViewParam = false } = queryParams || {};
        const isWebView = isWebViewParam === true || isWebViewParam === "true";

        if (isWebView) {
            const singlePageTdQueryVariant = getSinglePageTdQueryVariant(queryParams);

            if (singlePageTdQueryVariant !== undefined) {
                webViewExperiments.msiteSinglePageTd = singlePageTdQueryVariant;
            } else if (!webViewExperiments.msiteSinglePageTd) {
                webViewExperiments.msiteSinglePageTd = EXPERIMENT_TYPE.VARIANT_A;
            }
        }

        if (webViewExperiments && Object.keys(webViewExperiments).length > 0) {
            Object.entries(webViewExperiments).forEach(([key, value]) => {
                const reducerKey = WEB_VIEW_EXPERIMENT_TO_REDUCER_MAPPING[key];
                if (reducerKey) {
                    dispatch(setExperimentConnect(reducerKey, value));
                }
            });
        }

        if (isCDPExtendedWarrantySelected) {
            dispatch(updateExtendedWarrantySelection(isCDPExtendedWarrantySelected));
        }

    }, [dispatch, search]);

    return { resetStoreWithWebViewData };
};

export default useWebViewData;
